import { useState } from "react";
import { AuthComp } from "../../../auth/AuthComp";
import { Redirect } from "../../tools/Redirect";
import { LOGIN, MODIFICAINDIRIZZOSPEDIZIONE, RICEVIADOMICILIO, STRUTTURE } from "../../../global/urlMapping";
import { Box } from "@mui/system";
import { Button, Grid, Modal, Paper, Typography, Divider } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as LogoCerca } from "../../../resources/icone/Cerca.svg";
import { ReactComponent as LogoOspedale } from "../../../resources/icone/Ospedale.svg";
import { ReactComponent as LogoConsegnaCasa } from "../../../resources/icone/ConsegnaAcasa.svg"
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { postAppointmentConfirmAction } from "../../../modules/screening/actions";
import { setMessaggioAction } from "../../../modules/messaggio/actions";
import { ERRORE_UNEXPECTED } from "../../../global/messaggioLabels";
import { checkScreeningCLSelector } from "../../../modules/screeningColonRetto/selectors";
import { ricercaIscrizioneSelector } from "../../../modules/anagrafe/selectors"
import { postAdhesionCLAction } from "../../../modules/screeningColonRetto/actions";
import { ReactComponent as Warning } from "../../../resources/icone/warning.svg"
import { isDomicilioAttivo } from "../../../global/multiAsl";

export const AdesioneCL = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [modalConferma, setModalConferma] = useState(false);
    const [buttonModificaIndirizzo, setButtonModificaIndirizzo] = useState(false);
    const [buttonConsultaCentri, setButtonConsultaCentri] = useState(false);
    const [buttonRiceviDomicilio, setButtonRiceviDomicilio] = useState(false);
    const [buttonRitiraCentro, setButtonRitiraCentro] = useState(false);
    const checkScreeningCL = useSelector(checkScreeningCLSelector)
    const datiIscrizioneAsr = useSelector(ricercaIscrizioneSelector)?.value?.DatiMinimiIscrizione
    const aslAssistito = datiIscrizioneAsr?.CodiceAreaAssistenza ?? datiIscrizioneAsr?.CodiceAslAssistenza

    const invite = location?.state?.invite;
    const isModifica = (invite?.status === "INVITED" && invite?.type === "INVITE") || invite?.status === "CONFIRMED"
    const onClickConferma = () => {
        //Uguale alla modale di DOMICILIO-> se modifichi, aggiorna

        if (checkScreeningCL?.status === 200) {//se è candidatura spontanea
            dispatch(postAdhesionCLAction("COLLECTION_CENTER"));
        }
        else {
            dispatch(postAppointmentConfirmAction({
                "idAppointment": invite?.id,
                "withdrawalMethod": "COLLECTION_CENTER"
            }))
        }
    }
    useEffect(() => {
        if (checkScreeningCL?.status === 200) {
            setButtonModificaIndirizzo(false)
            if (isDomicilioAttivo(aslAssistito)) {
                setButtonRiceviDomicilio(true)
            } else {
                setButtonRiceviDomicilio(false)
            }
            setButtonConsultaCentri(true)
            setButtonRitiraCentro(true)
        } else if ((invite?.type === "SCREENING_CENTER_INVITE" || invite?.type === "REMINDER" || invite?.type === "INVITE") && invite?.status === "INVITED") {
            setButtonModificaIndirizzo(false)
            if (isDomicilioAttivo(aslAssistito)) {
                setButtonRiceviDomicilio(true)
            } else {
                setButtonRiceviDomicilio(false)
            }
            setButtonConsultaCentri(true)
            setButtonRitiraCentro(true)
        } else if (isModifica && invite?.withdrawalMethod === "SHIPPED") {
            if (isDomicilioAttivo(aslAssistito)) {
                setButtonModificaIndirizzo(true)
            } else {
                setButtonModificaIndirizzo(false)
            }
            setButtonRiceviDomicilio(false)
            setButtonConsultaCentri(true)
            setButtonRitiraCentro(true)
        } else if (isModifica && invite?.withdrawalMethod === "COLLECTION_CENTER") {
            setButtonModificaIndirizzo(false)
            if (isDomicilioAttivo(aslAssistito)) {
                setButtonRiceviDomicilio(true)
            } else {
                setButtonRiceviDomicilio(false)
            }
            setButtonConsultaCentri(false)
            setButtonRitiraCentro(false)
        } else if (invite?.status === "DECLINED") {
            setButtonModificaIndirizzo(false)
            if (isDomicilioAttivo(aslAssistito)) {
                setButtonRiceviDomicilio(true)
            } else {
                setButtonRiceviDomicilio(false)
            }
            setButtonConsultaCentri(true)
            setButtonRitiraCentro(true)
        } else {
            dispatch(setMessaggioAction({ status: ERRORE_UNEXPECTED }))
        }

    }, [checkScreeningCL?.status, invite, isModifica, navigate, dispatch, aslAssistito])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <Box className="bg"
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%"
                }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    {isModifica ?
                                        "Modifica la modalità di ricezione del tuo kit ed esito" :
                                        "Scegli come ottenere il kit per lo screening"}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 4, mx: 'auto', paddingBottom: "20vh" }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>
                            <Box
                                sx={{
                                    width: "80%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >

                                {buttonModificaIndirizzo &&
                                    <>
                                        <Paper
                                            className="change-cursor"
                                            elevation={6}
                                            sx={{
                                                minHeight: "150px",
                                                borderRadius: "20px",
                                                textDecoration: "none !important",
                                                display: "flex",
                                                width: { xs: "100%", md: "80%" },
                                                padding: "0px",
                                                margin: "auto",
                                                marginBottom: "42px"
                                            }}
                                            onClick={() => { navigate(MODIFICAINDIRIZZOSPEDIZIONE, { state: { invite } }); }}
                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor: "transparent",
                                                    minHeight: "100px",
                                                    width: "100%",
                                                    margin: "auto 0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"

                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <LogoConsegnaCasa style={{ width: "80px", marginLeft: "40px", display: "flex", marginRight: "20px" }} />
                                                    <Typography
                                                        component='h2'
                                                        sx={{
                                                            color: "#005397",
                                                            fontSize: { xs: "20px", md: "25px" },
                                                            fontWeight: 700,

                                                        }}
                                                    >
                                                        {"Modifica indirizzo di spedizione"}
                                                    </Typography>
                                                </Box>
                                                <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                            </Box>
                                        </Paper>

                                        <Divider sx={{ color: "005397", width: '70%', margin: '0 auto', marginBottom: "42px" }}>
                                            <Typography
                                                component='h2'
                                                sx={{
                                                    color: "#005397",
                                                    fontSize: { xs: "14px", md: "18px" },
                                                    fontWeight: 650,
                                                    fontStyle: "italic"
                                                }}>
                                                Oppure
                                            </Typography>
                                        </Divider>
                                    </>}

                                {buttonConsultaCentri &&
                                    <>
                                        <Paper
                                            elevation={6}
                                            sx={{
                                                minHeight: "150px",
                                                borderRadius: "20px",
                                                textDecoration: "none !important",
                                                display: "flex",
                                                width: { xs: "100%", md: "80%" },
                                                padding: "0px",
                                                margin: "auto",
                                                marginBottom: "42px"
                                            }}
                                            component={Link}
                                            to={STRUTTURE}

                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor: "transparent",
                                                    minHeight: "100px",
                                                    width: "100%",
                                                    margin: "auto 0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <LogoCerca style={{ width: "50px", marginLeft: "40px", display: "flex", marginRight: "20px" }} />
                                                    <Typography
                                                        component='h2'
                                                        sx={{
                                                            color: "#005397",
                                                            fontSize: { xs: "20px", md: "25px" },
                                                            fontWeight: 700,

                                                        }}
                                                    >
                                                        {"Consulta i centri di distribuzione del kit"}
                                                    </Typography>
                                                </Box>
                                                <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                            </Box>
                                        </Paper>
                                    </>
                                }

                                {buttonRitiraCentro &&
                                    <>
                                        <Paper
                                            className="change-cursor"
                                            elevation={6}
                                            sx={{
                                                minHeight: "150px",
                                                borderRadius: "20px",
                                                textDecoration: "none !important",
                                                display: "flex",
                                                width: { xs: "100%", md: "80%" },
                                                padding: "0px",
                                                margin: "auto",
                                                marginBottom: "42px"
                                            }}
                                            onClick={() => {
                                                setModalConferma(true);
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor: "transparent",
                                                    minHeight: "100px",
                                                    width: "100%",
                                                    margin: "auto 0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <LogoOspedale style={{ width: "40px", marginLeft: "40px", display: "flex", marginRight: "20px" }} />
                                                    <Typography
                                                        component='h2'
                                                        sx={{
                                                            color: "#005397",
                                                            fontSize: { xs: "20px", md: "25px" },
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        {"Ritira in un centro di distribuzione"}
                                                    </Typography>
                                                </Box>
                                                <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                            </Box>
                                        </Paper>

                                        {!buttonModificaIndirizzo && buttonRiceviDomicilio &&
                                            <Divider sx={{ color: "005397", width: '70%', margin: '0 auto', marginBottom: "42px" }}>
                                                <Typography
                                                    component='h2'
                                                    sx={{
                                                        color: "#005397",
                                                        fontSize: { xs: "14px", md: "18px" },
                                                        fontWeight: 650,
                                                        fontStyle: "italic"
                                                    }}>
                                                    Oppure
                                                </Typography>
                                            </Divider>
                                        }
                                    </>
                                }

                                {buttonRiceviDomicilio &&
                                    <Paper
                                        className="change-cursor"
                                        elevation={6}
                                        sx={{
                                            minHeight: "150px",
                                            borderRadius: "20px",
                                            textDecoration: "none !important",
                                            display: "flex",
                                            width: { xs: "100%", md: "80%" },
                                            padding: "0px",
                                            margin: "auto",
                                            marginBottom: "42px"
                                        }}
                                        onClick={() => { navigate(RICEVIADOMICILIO, { state: { invite } }); }}


                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: "transparent",
                                                minHeight: "100px",
                                                width: "100%",
                                                margin: "auto 0",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <LogoConsegnaCasa style={{ width: "40px", marginLeft: "40px", display: "flex", marginRight: "20px" }} />
                                                <Typography
                                                    component='h2'
                                                    sx={{
                                                        color: "#005397",
                                                        fontSize: { xs: "20px", md: "25px" },
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    {"Ricevi il tuo kit a domicilio"}
                                                </Typography>
                                            </Box>
                                            <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                        </Box>
                                    </Paper>}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {
                modalConferma &&
                <Modal
                    open={modalConferma}
                    disableAutoFocus
                    sx={{ width: "100%", display: "flex" }}
                >
                    <Box
                        sx={{
                            width: "380px",
                            minHeight: "320px",
                            display: "flex",
                            flexDirection: "column",
                            margin: "auto",
                            backgroundColor: "white",
                            borderRadius: "20px",
                        }}
                    >
                        <Box
                            sx={{
                                minHeight: "120px",
                                display: "flex",
                                width: "100%",
                                margin: "auto",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Warning
                                sx={{
                                    display: "flex",
                                    margin: "auto",
                                }}
                            />
                            <Typography
                                sx={{
                                    color: "#D1AE00",
                                    wordWrap: "break-word",
                                    margin: "auto",
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    textAlign: "center",
                                    marginBottom: "5px"
                                }}
                                component="h1"
                            >
                                Attenzione
                            </Typography>
                        </Box>
                        <Divider
                            variant="middle"
                            sx={{
                                width: "70%",
                                margin: "10px auto",
                            }}
                        />
                        <Typography
                            sx={{
                                fontSize: "16px",
                                color: "black",
                                fontWeight: "medium",
                                textAlign: "center",
                                margin: "auto",
                                mx: "10px"
                            }}
                        >
                            Vuoi confermare l'operazione di ritiro presso un centro di distribuzione?
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                mt: "20px",
                                mb: "20px",
                            }}
                        >
                            <Button
                                sx={{
                                    borderWidth: '2px',
                                    borderColor: '#005397',
                                    "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                    color: '#005397',
                                    borderRadius: '20px',
                                    fontWeight: 700,
                                    fontSize: { md: "14px", xs: "12px" }
                                }}
                                variant="outlined"
                                onClick={() => { setModalConferma(false); }}
                            >
                                Annulla
                            </Button>
                            <Button
                                sx={{
                                    borderWidth: '2px',
                                    borderColor: '#005397',
                                    bgcolor: "#005397",
                                    "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px' },
                                    color: 'white',
                                    borderRadius: '20px',
                                    fontWeight: 700,
                                    fontSize: { md: "14px", xs: "12px" }
                                }}
                                variant="outlined"
                                onClick={() => { setModalConferma(false); onClickConferma() }}
                            >
                                Conferma
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            }

        </AuthComp >
    );
}